import { useCallback } from 'react';
import { useTexts, useTranslation } from '@/feature/lang';

export const useReportTypeName = () => {
  const { translate } = useTranslation();
  const typeOptions = useTexts().rms.reports.model.type.options;

  return useCallback(
    (reportType: string) => {
      switch (reportType) {
        case 'rms-monthly':
          return translate(typeOptions.rmsMonthly) ?? reportType;
        default:
          return reportType;
      }
    },
    [typeOptions, translate]
  );
};
